import _ from 'lodash';
import Combinatorics from 'js-combinatorics';

import {
  SOCKET_TYPES,
  canAddSocket,
  doesItemDrop,
  getBonusUpgradeSet,
  getCraftedStats,
  getItemBonusForDelta,
  getItemSocketBonusId,
  getPossibleItemConversions,
  getSeasonBonusForLevel,
  getWeaponHands,
  hasCraftedStats,
  isItemUsable,
  itemSocketInfo,
  professionCraftingQualities,
  removeItemLevelBonuses,
  slotMap,
} from 'shared/items';
import { getSpecInfo } from 'shared/character';
import { addTag } from 'shared/itemTags';

import GameData from 'shared/gameData';

let loaded = false;

let Instances;
let Encounters;
let EncounterItems;


const loadStaticData = data => {
  if (!loaded) {
    EncounterItems = data.EncounterItems;
    Instances = data.Instances;

    Encounters = _.flatten(_.map(Instances, 'encounters'));
    loaded = true;
  }
};

const WARFORGED_BONUS_ID = 4783;
const TITANFORGED_BONUS_ID = 4784;

const jewelryIgnoreInstances = [
  536,
  558,
];
const mythicPlusItemFilter = (item) => {
  const slot = slotMap[item.inventoryType];
  if (slot === 'neck' || slot === 'finger') {
    const ignoredInstance = _.some(item.sources, s => _.includes(jewelryIgnoreInstances, s.instanceId));
    return !ignoredInstance;
  }
  return true;
};


const MPLUS_ITEM_LEVELS = [{
  id: 'dungeon-mythic2',
  name: 'Mythic 2',
  itemLevelOverride: 402,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5440, // Mythic 2
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic3',
  name: 'Mythic 3',
  itemLevelOverride: 405,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5441, // Mythic 3
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic4',
  name: 'Mythic 4',
  itemLevelOverride: 405,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5442, // Mythic 4
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic5',
  name: 'Mythic 5',
  itemLevelOverride: 408,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5443, // Mythic 5
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic6',
  name: 'Mythic 6',
  itemLevelOverride: 408,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5444, // Mythic 6
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic7',
  name: 'Mythic 7',
  itemLevelOverride: 411,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5445, // Mythic 7
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic8',
  name: 'Mythic 8',
  itemLevelOverride: 411,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5446, // Mythic 8
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic9',
  name: 'Mythic 9',
  itemLevelOverride: 415,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5447, // Mythic 9
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic10',
  name: 'Mythic 10',
  itemLevelOverride: 415,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    5448, // Mythic 10
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic11',
  name: 'Mythic 11',
  itemLevelOverride: 418,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3509, // Mythic 11
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic12',
  name: 'Mythic 12',
  itemLevelOverride: 418,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3510, // Mythic 12
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic13',
  name: 'Mythic 13',
  itemLevelOverride: 421,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3534, // Mythic 13
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic14',
  name: 'Mythic 14',
  itemLevelOverride: 421,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3535, // Mythic 14
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic15',
  name: 'Mythic 15',
  itemLevelOverride: 424,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    3536, // Mythic 15
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic16',
  name: 'Mythic 16',
  itemLevelOverride: 424,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    // TODO: Figure out what tag is used here
    6808, // Mythic
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic17',
  name: 'Mythic 17',
  itemLevelOverride: 428,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    // TODO: Figure out what tag is used here
    6808, // Mythic
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic18',
  name: 'Mythic 18',
  itemLevelOverride: 428,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    // TODO: Figure out what tag is used here
    6808, // Mythic
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic19',
  name: 'Mythic 19',
  itemLevelOverride: 431,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    // TODO: Figure out what tag is used here
    6808, // Mythic
    4786, // epic
  ],
}, {
  id: 'dungeon-mythic20',
  name: 'Mythic 20',
  itemLevelOverride: 431,
  itemFilter: mythicPlusItemFilter,
  bonusIds: [
    // TODO: Figure out what tag is used here
    6808, // Mythic
    4786, // epic
  ],
}];

const MPLUS_DIFFICULTIES = [
  // ======================================================
  // Merge in mlpus levels into mplus-chest type
  // We also reuse these item levels for M+ timewalking
  ..._.map(MPLUS_ITEM_LEVELS, itemLevelInfo => ({
    type: 'mplus-chest',
    ...itemLevelInfo,
  })),
  {
    id: 'dungeon-mythic-weekly12',
    type: 'mplus-chest',
    name: '+12-13 Vault',
    itemLevelOverride: 434,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      5450, // Mythic 12
      4786, // epic
    ],
  }, {
    id: 'dungeon-mythic-weekly14',
    type: 'mplus-chest',
    name: '+14-15 Vault',
    itemLevelOverride: 437,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      3512, // Mythic 14
      4786, // epic
    ],
  }, {
    id: 'dungeon-mythic-weekly16',
    type: 'mplus-chest',
    name: '+16-17 Vault',
    itemLevelOverride: 441,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      // TODO: Figure out what tag is used here
      6808, // Mythic
      4786, // epic
    ],
  }, {
    id: 'dungeon-mythic-weekly18',
    type: 'mplus-chest',
    name: '+18-19 Vault',
    itemLevelOverride: 444,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      // TODO: Figure out what tag is used here
      6808, // Mythic
      4786, // epic
    ],
  }, {
    id: 'dungeon-mythic-weekly20',
    type: 'mplus-chest',
    name: '+20 Vault',
    itemLevelOverride: 447,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      // TODO: Figure out what tag is used here
      6808, // Mythic
      4786, // epic
    ],
  },
];

/*
const TIMEWALKING_DIFFICULTIES = [
  ..._.map(MPLUS_ITEM_LEVELS, itemLevelInfo => ({
    type: 'mplus-timewalking',
    ...itemLevelInfo,
  })), {
    id: 'dungeon-upgrade-10',
    type: 'mplus-timewalking',
    name: 'Upgrade Level 10',
    itemLevelOverride: 291,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      7604, // Upgrade Level 10
      4786, // epic
    ],
  }, {
    id: 'dungeon-upgrade-11',
    type: 'mplus-timewalking',
    name: 'Upgrade Level 11',
    itemLevelOverride: 294,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      7605, // Upgrade Level 11
      4786, // epic
    ],
  }, {
    id: 'dungeon-upgrade-12',
    type: 'mplus-timewalking',
    name: 'Upgrade Level 12',
    itemLevelOverride: 298,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      7606, // Upgrade Level 12
      4786, // epic
    ],
  },
];
*/

const professionLevelUpgrades = [{
  key: 'base',
  name: 'Base',
}, {
  key: 'base333',
  name: 'Training Matrix I',
  baseLevel: 333,
  itemId: 198048,
  itemQuality: 3,
}, {
  key: 'base346',
  name: 'Training Matrix II',
  baseLevel: 346,
  itemId: 198056,
  itemQuality: 3,
}, {
  key: 'base359',
  name: 'Training Matrix III',
  baseLevel: 359,
  itemId: 198058,
  itemQuality: 3,
}, {
  key: 'base372',
  name: 'Training Matrix IV',
  baseLevel: 372,
  itemId: 198059,
  itemQuality: 4,
}, {
  key: 'base395',
  name: 'Primal Infusion',
  baseLevel: 395,
  itemId: 197921,
  itemQuality: 4,
}, {
  key: 'base408',
  name: 'Concentrated Primal Infusion',
  baseLevel: 408,
  itemId: 198046,
  itemQuality: 4,
}, {
  key: 'base411',
  name: 'Spark of Shadowflame',
  baseLevel: 411,
  itemId: 204440,
  itemQuality: 4,
}, {
  key: 'base424',
  name: 'Enchanted Wyrm\'s Shadowflame Crest',
  baseLevel: 424,
  itemId: 204682,
  itemQuality: 4,
}, {
  key: 'base434',
  name: 'Enchanted Aspect\'s Shadowflame Crest',
  baseLevel: 434,
  itemId: 204697,
  itemQuality: 4,
}];

// This can get a bit weird if there's a "jagged" item level band of early items
// DF launch has some 306 items that are obnoxious
const professionDifficulties = (baseLevel, maxLevel = Infinity) => _.filter(_.map(
  Combinatorics.cartesianProduct(professionCraftingQualities, professionLevelUpgrades).toArray(),
  ([craftingQuality, levelUpgrade]) => {
    const base = levelUpgrade.baseLevel || baseLevel;
    const level = base + craftingQuality.levelOffset;
    if (!levelUpgrade.baseLevel || (baseLevel < levelUpgrade.baseLevel && level <= maxLevel)) {
      return {
        id: `profession${baseLevel}-${level}-${_.camelCase(levelUpgrade.name)})`,
        type: `profession${baseLevel}`,
        name: `${levelUpgrade.name}, Quality ${craftingQuality.tier}`,
        itemLevelOverride: level,
        craftingQuality: craftingQuality.tier,

        itemId: levelUpgrade.itemId,
        itemQuality: levelUpgrade.itemQuality,
      };
    }
    return null;
  },
));

const PROFESSION_DIFFICULTIES = [
  ...professionDifficulties(333, 382),
  ...professionDifficulties(382),
];

const isNewPrimalStormItem = item => {
  // remove the 10.0.5 items from the low level group
  const slot = slotMap[item.inventoryType];
  return _.includes(['neck', 'finger', 'trinket'], slot);
};

export const DIFFICULTIES = [
  ...MPLUS_DIFFICULTIES,
  //...TIMEWALKING_DIFFICULTIES,
  {
    id: 'dungeon-normal',
    type: 'expansion-dungeon',
    name: 'Normal',
    quality: 3, // rare
    itemLevelOverride: 382,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      7022, // Heroic
      7244, // rare
    ],
  }, {
    id: 'dungeon-heroic',
    type: 'expansion-dungeon',
    name: 'Heroic',
    quality: 3, // rare
    itemLevelOverride: 389,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      7022, // Heroic
      7244, // rare
    ],
  }, {
    id: 'dungeon-mythic1',
    type: 'expansion-dungeon',
    name: 'Mythic',
    itemLevelOverride: 398,
    itemFilter: mythicPlusItemFilter,
    bonusIds: [
      6808, // Mythic
      4786, // epic
    ],
  }, {
    id: 'raid-lfr',
    type: 'raid',
    name: 'Raid Finder',
    bonusIds: [
      4825, // Raid Finder
      4786, // epic
    ],
  }, {
    id: 'raid-lfr-upgraded',
    type: 'raid',
    name: 'Raid Finder',
    bonusIds: [
      4825, // Raid Finder
      4786, // epic
    ],
    itemLevel: 'Veteran 4/8',
  }, {
    id: 'raid-lfr-upgraded-max',
    type: 'raid',
    name: 'Raid Finder',
    bonusIds: [
      4825, // Raid Finder
      4786, // epic
    ],
    itemLevel: 'Max Upgrades',
  }, {
    id: 'raid-normal',
    type: 'raid',
    name: 'Normal',
    bonusIds: [
      4822, // Normal (doesn't actually do anything)
      4786, // epic
    ],
  }, {
    id: 'raid-normal-upgraded',
    type: 'raid',
    name: 'Normal',
    bonusIds: [
      4822, // Normal (doesn't actually do anything)
      4786, // epic
    ],
    itemLevel: 'Champion 4/8',
  }, {
    id: 'raid-normal-upgraded-max',
    type: 'raid',
    name: 'Normal',
    bonusIds: [
      4822, // Normal (doesn't actually do anything)
      4786, // epic
    ],
    itemLevel: 'Max Upgrades',
  }, {
    id: 'raid-heroic',
    type: 'raid',
    name: 'Heroic',
    bonusIds: [
      4799, // Heroic
      4786, // epic
    ],
  }, {
    id: 'raid-heroic-upgraded',
    type: 'raid',
    name: 'Heroic',
    bonusIds: [
      4799, // Heroic
      4786, // epic
    ],
    itemLevel: 'Hero 4/5',
  }, {
    id: 'raid-heroic-upgraded-max',
    type: 'raid',
    name: 'Heroic',
    bonusIds: [
      4799, // Heroic
      4786, // epic
    ],
    itemLevel: 'Max Upgrades',
  }, {
    id: 'raid-mythic',
    type: 'raid',
    name: 'Mythic',
    bonusIds: [
      4800, // Mythic
      4786, // epic
    ],
  }, {
    id: 'raid-mythic-upgraded',
    type: 'raid',
    name: 'Mythic',
    bonusIds: [
      4800, // Mythic
      4786, // epic
    ],
    itemLevel: 'Myth 3/3',
  /*
  }, {
    id: 'raid-lfr-fated',
    type: 'raid',
    name: 'Fated Raid Finder',
    bonusIds: [
      8756, // Fated Raid Finder
      4786, // epic
    ],
    itemLevel: '265 - 272',
    itemLevelOverride: 265,
  }, {
    id: 'raid-normal-fated',
    type: 'raid',
    name: 'Fated Normal',
    bonusIds: [
      8761, // "Fated"
      4786, // epic
    ],
    itemLevel: '278 - 285',
    itemLevelOverride: 278,
  }, {
    id: 'raid-heroic-fated',
    type: 'raid',
    name: 'Fated Heroic',
    bonusIds: [
      8764, // Fated Heroic
      4786, // epic
    ],
    itemLevel: '291 - 298',
    itemLevelOverride: 291,
  }, {
    id: 'raid-mythic-fated',
    type: 'raid',
    name: 'Fated Mythic',
    bonusIds: [
      8762, // Fated Mythic
      4786, // epic
    ],
    itemLevel: '304 - 311',
    itemLevelOverride: 304,
    */
  }, {
    id: 'dungeon-normal',
    type: 'dungeon',
    name: 'Normal',
  }, {
    id: 'dungeon-heroic',
    type: 'dungeon',
    name: 'Heroic',
  }, {
    id: 'dungeon-mythic',
    type: 'dungeon',
    name: 'Mythic',

  }, {

    // PVP VENDORS

    id: 'pvp-honor-1',
    type: 'pvp-honor',
    name: 'Rank 1',
    quality: 3,
    itemLevelOverride: 366,
    bonusIds: [
      9421, // Upgrade 1/5
    ],
  }, {
    id: 'pvp-honor-2',
    type: 'pvp-honor',
    name: 'Rank 2',
    quality: 3,
    itemLevelOverride: 372,
    bonusIds: [
      9422, // Upgrade 2/5
    ],
  }, {
    id: 'pvp-honor-3',
    type: 'pvp-honor',
    name: 'Rank 3',
    quality: 3,
    itemLevelOverride: 379,
    bonusIds: [
      9423, // Rank 3
    ],
  }, {
    id: 'pvp-honor-4',
    type: 'pvp-honor',
    name: 'Rank 4',
    quality: 3,
    itemLevelOverride: 385,
    bonusIds: [
      9424, // Rank 4
    ],
  }, {
    id: 'pvp-honor-5',
    type: 'pvp-honor',
    name: 'Rank 5',
    itemLevelOverride: 392,
    bonusIds: [
      9425, // Rank 5
    ],

  }, {
    // Conquest Shadowlands Season 1

    id: 'pvp-conquest-1',
    type: 'pvp-conquest',
    name: 'Rank 1',
    itemLevelOverride: 408,
    bonusIds: [
      9426, // 1/9
    ],
  }, {
    id: 'pvp-conquest-2',
    type: 'pvp-conquest',
    name: 'Rank 2',
    itemLevelOverride: 411,
    bonusIds: [
      9427, // 2/9
    ],
  }, {
    id: 'pvp-conquest-3',
    type: 'pvp-conquest',
    name: 'Rank 3',
    itemLevelOverride: 415,
    bonusIds: [
      9428, // 3/9
    ],
  }, {
    id: 'pvp-conquest-4',
    type: 'pvp-conquest',
    name: 'Rank 4',
    itemLevelOverride: 418,
    bonusIds: [
      9429, // 4/9
    ],
  }, {
    id: 'pvp-conquest-5',
    type: 'pvp-conquest',
    name: 'Rank 5',
    itemLevelOverride: 421,
    bonusIds: [
      9430, // 5/9
    ],
  }, {
    id: 'pvp-conquest-6',
    type: 'pvp-conquest',
    name: 'Rank 6',
    itemLevelOverride: 424,
    bonusIds: [
      9431, // 6/9
    ],
  }, {
    id: 'pvp-conquest-7',
    type: 'pvp-conquest',
    name: 'Rank 7',
    itemLevelOverride: 428,
    bonusIds: [
      9432, // 7/9
    ],
  }, {
    id: 'pvp-conquest-8',
    type: 'pvp-conquest',
    name: 'Rank 8',
    itemLevelOverride: 431,
    bonusIds: [
      9433, // 8/9
    ],
  }, {
    id: 'pvp-conquest-9',
    type: 'pvp-conquest',
    name: 'Rank 9',
    itemLevelOverride: 434,
    bonusIds: [
      9434, // 9/9
    ],

  }, {
    id: 'megadungeon-normal',
    type: 'megadungeon',
    name: 'Normal',
    itemLevelOverride: 437,
  }, {
    id: 'megadungeon-upgraded-max',
    type: 'megadungeon',
    name: 'Normal',
    itemLevel: 'Max Upgrades',
  }, {
    id: 'megadungeon-hard',
    type: 'megadungeon',
    name: 'Hard Mode',
    itemLevelOverride: 437,
    itemLevel: '437 - 441',
  }, {
    id: 'megadungeon-hard-upgraded-max',
    type: 'megadungeon',
    name: 'Hard Mode',
    itemLevelOverride: 437,
    itemLevel: 'Max Upgrades',
  },

  ..._.reject(_.map(_.uniqBy(MPLUS_DIFFICULTIES, 'itemLevelOverride'), itemLevelInfo => ({
    id: `catalyst-${itemLevelInfo.itemLevelOverride}`,
    type: 'catalyst',
    itemLevelOverride: itemLevelInfo.itemLevelOverride,
  })), (diff) => !diff.itemLevelOverride),

  ...PROFESSION_DIFFICULTIES,

  {
    id: 'primalStorms-rare',
    type: 'primalStorms',
    name: 'Level 1',
    itemLevelOverride: 359,
    quality: 3,
    itemFilter: (item) => !isNewPrimalStormItem(item),
  }, {
    id: 'primalStorms-epic',
    type: 'primalStorms',
    name: 'Level 2',
    quality: 4,
    itemLevelOverride: 385,
    bonusIds: [
      8943, // "Primal Infused" tag
    ],
    itemFilter: (item) => !isNewPrimalStormItem(item),
  }, {
    id: 'primalStorms-389',
    type: 'primalStorms',
    name: 'Rings, Neck, Trinket',
    quality: 4,
    itemLevelOverride: 389,
    bonusIds: [
      8943, // "Primal Infused" tag
    ],
    itemFilter: (item) => isNewPrimalStormItem(item),
  }, {
    id: 'primalStorms-3',
    type: 'primalStorms',
    name: 'Level 3',
    quality: 4,
    itemLevelOverride: 395,
    bonusIds: [
      // this is a guess, seems logical
      9378, // "Primal Empowered" tag
    ],
    itemFilter: (item) => !isNewPrimalStormItem(item),
  }, {

    id: 'timeRifts',
    type: 'solo',
    name: 'Time Rifts',
    quality: 4,
    itemLevelOverride: 402,
    season: 'df2',
  }, {
    id: 'timeRifts-upgraded-max',
    type: 'solo',
    name: 'Time Rifts',
    itemLevelOverride: 402,
    itemLevel: 'Max Upgrades',
  },
];

export const INSTANCE_OVERRIDES = [{

  /////////////////////////////////////////////////////////////////////////////////
  //
  // Dragonflight
  //
  /////////////////////////////////////////////////////////////////////////////////

  //////////////////////////////////////
  // Dragonflight Season 2
  //////////////////////////////////////

  // Dawn of the Infinite is season 2
  instanceId: -50,
  season: 'df2',

  warning: {
    text: 'Trinkets are still being implemented, sims may not be accurate for them',
  },
}, {

  // Dawn of the Infinite is season 2
  instanceId: 1209,
  season: 'df2',
}, {

  // 10.0 Vault of the Incarnates raid
  instanceId: 1208,
  season: 'df2',

}, {

  // 10.0 CATALYST - tier upgrader
  instanceId: -46,
  season: 'df2',

  disableWarforgeLevel: true,

  enableSockets: true,

  showChances: false,
}, {
  // MYTHIC+ END OF DUNGEON CHEST
  instanceId: -1,
  season: 'df2',

  showEncounters: true,

  encounterType: 'dungeon',
  encounterTypePlural: 'dungeons',
  encounterAllId: -1,

  enableSockets: true,
  repeatable: true,
}, {

  // 10.1 PVP Conquest
  instanceId: -47,
  season: 'df2',

  showChances: false,
}, {
  // 10.1 PVP Honor
  instanceId: -48,
  season: 'df2',

  showChances: false,
}, {

  //////////////////////////////////////
  // Dragonflight Season 1
  //////////////////////////////////////

  // 10.0 PVP Conquest
  instanceId: -31,
  season: 'df1',

  showChances: false,

  archive: true,
}, {
  // 10.0 PVP Honor
  instanceId: -30,
  season: 'df1',

  showChances: false,

  archive: true,
}, {
  // 10.0 Vault of the Incarnates raid
  instanceId: 1200,
  season: 'df1',

  archive: true,
}, {
  // 10.0 PRIMAL STORMS
  instanceId: -45,
  season: 'df1',

  showEncounters: false,

  enableSockets: false,

  showChances: false,

  archive: true,
}, {

  // PROFESSIONS 382 items
  instanceId: -42,
  disableDifficulties: false,

  showEncounters: false,

  encounterType: 'profession',
  encounterTypePlural: 'professions',
  encounterAllId: -42,

  showChances: false,

  enableSockets: true,

  // NOT seasonal gear
  season: '',
}, {
  // PROFESSIONS 333 items
  instanceId: -41,
  disableDifficulties: false,

  showEncounters: false,

  encounterType: 'profession',
  encounterTypePlural: 'professions',
  encounterAllId: -41,

  showChances: false,

  enableSockets: true,

  warning: {
    text: '306 items and Titan Training Matrix I infusions are not supported',
  },

  // NOT seasonal gear
  season: '',

  archive: true,
}, {
  // WORLD BOSSES
  instanceId: 1205,
  season: 'df1',
  disableDifficulties: true,

  itemLevelOverride: 395,

  enableSockets: true,
}, {
  // Normal/Heroic/M0 Dungeons
  instanceId: -32,
  // NOT seasonal gear
  season: '',

  showEncounters: true,

  encounterType: 'dungeon',
  encounterTypePlural: 'dungeons',
  encounterAllId: -32,

  enableSockets: true,
  repeatable: true,

}];

export const SEASONS = {
  df2: {
    disableWarforgeLevel: true,
    enableSockets: true,

    // Dragonflight season 2 Revival Catalyst conversion
    itemConversion: {
      id: 6,
      minLevel: 402, // TODO: This is a guess based on lowest level of LFR drops
    },
  },
  df1: {
    disableWarforgeLevel: true,
    enableSockets: true,

    // Dragonflight season 1 Revival Catalyst conversion
    itemConversion: {
      id: 3,
      minLevel: 376,
    },
  },
  // 9.2.7
  sl4: {
    disableWarforgeLevel: true,
    enableSockets: true,
  },
  // 9.2
  sl3: {
    disableWarforgeLevel: true,
    enableSockets: true,
  },
  // 9.1
  sl2: {
    disableWarforgeLevel: true,
    enableSockets: true,
  },
  // 9.0
  sl1: {
    disableWarforgeLevel: true,
  },
  bfa4: {
    disableWarforgeLevel: true,
  },
  bfa3: {
    warforgeMax: 455,
  },
  bfa2: {
    warforgeMax: 425,
  },
};

const OFFSET_LFR = -13;
const OFFSET_NORMAL = 0;
const OFFSET_HEROIC = 13;
const OFFSET_MYTHIC = 26;

export const INSTANCE_DIFFICULTY_OVERRIDES = [{

  // Time Rifts Max Upgrade
  instanceId: -50,
  difficulty: 'timeRifts-upgraded-max',
  maxUpgrade: true,
}, {

  // Dawn of the Infinite max upgrade

  instanceId: 1209,
  difficulty: 'megadungeon-upgraded-max',
  itemLevelOverride: 437,
  maxUpgrade: true,
}, {
  instanceId: 1209,
  difficulty: 'megadungeon-hard-upgraded-max',
  itemLevelOverride: 437,
  maxUpgrade: true,
}, {

  // 10.1 Aberrus, the Shadowed Crucible

  instanceId: 1208,
  difficulty: 'raid-lfr',
  itemLevel: '402 - 418',
  itemLevelOffset: OFFSET_LFR,
}, {
  instanceId: 1208,
  difficulty: 'raid-lfr-upgraded',
  itemLevelOffset: OFFSET_LFR,
  itemLevelMin: 411,
}, {
  instanceId: 1208,
  difficulty: 'raid-lfr-upgraded-max',
  itemLevelOffset: OFFSET_LFR,
  maxUpgrade: true,
}, {
  instanceId: 1208,
  difficulty: 'raid-normal',
  itemLevel: '415 - 431',
  itemLevelOffset: OFFSET_NORMAL,
}, {
  instanceId: 1208,
  difficulty: 'raid-normal-upgraded',
  itemLevelOffset: OFFSET_NORMAL,
  itemLevelMin: 424,
}, {
  instanceId: 1208,
  difficulty: 'raid-normal-upgraded-max',
  itemLevelOffset: OFFSET_NORMAL,
  maxUpgrade: true,
}, {
  instanceId: 1208,
  difficulty: 'raid-heroic',
  itemLevel: '428 - 444',
  itemLevelOffset: OFFSET_HEROIC,
}, {
  instanceId: 1208,
  difficulty: 'raid-heroic-upgraded',
  itemLevelOffset: OFFSET_HEROIC,
  itemLevelMin: 437,
}, {
  instanceId: 1208,
  difficulty: 'raid-heroic-upgraded-max',
  itemLevelOffset: OFFSET_HEROIC,
  maxUpgrade: true,
}, {
  instanceId: 1208,
  difficulty: 'raid-mythic',
  itemLevel: '441 - 457',
  itemLevelOffset: OFFSET_MYTHIC,
}, {
  instanceId: 1208,
  difficulty: 'raid-mythic-upgraded',
  itemLevelOffset: OFFSET_MYTHIC,
  itemLevelMin: 447,

}, {

  // 10.0 Vault of the Incarnates

  instanceId: 1200,
  difficulty: 'raid-lfr',
  itemLevel: '376 - 392',
  itemLevelOffset: -13,
}, {
  instanceId: 1200,
  difficulty: 'raid-normal',
  itemLevel: '389 - 405',
  itemLevelOffset: 0,
}, {
  instanceId: 1200,
  difficulty: 'raid-heroic',
  itemLevel: '402 - 418',
  itemLevelOffset: 13,
}, {
  instanceId: 1200,
  difficulty: 'raid-mythic',
  itemLevel: '415 - 430',
  itemLevelOffset: 26,

}];

const ENCOUNTER_OVERRIDES = [{

  // Dawn of the Infinite hard mode last boss
  encounterId: 2538,
  difficulty: 'megadungeon-hard',
  itemLevelOverride: 441,
}, {
  encounterId: 2538,
  difficulty: 'megadungeon-hard-upgraded-max',
  itemLevelOverride: 441,
}, {

  // Zaqali Elders world boss
  encounterId: 2531,
  itemLevelOverride: 415,
  season: 'df2',

/*
{
  ///////////////////////////////////////////////
  // 9.2.7 FATED RAIDS
  // Also simplify fixed increased  ilevel bosses

  // THE JAILER
  encounterId: 2464,
  encounterLevelOffset: 7,
}, {
  // RYGELON
  encounterId: 2467,
  encounterLevelOffset: 7,
}, {
  // LORDS OF DREAD
  encounterId: 2457,
  encounterLevelOffset: 7,
}, {
  // SANCTUM OF DOMINATION
  // KEL'THUZAD
  encounterId: 2440,
  encounterLevelOffset: 7,
}, {
  // SYLVANAS WINDRUNNER
  encounterId: 2441,
  encounterLevelOffset: 7,
}, {
  // CASTLE NATHRIA
  // STONE LEGION GENERALS
  encounterId: 2425,
  encounterLevelOffset: 7,
}, {
  // SIRE DENATHRIUS
  encounterId: 2424,
  encounterLevelOffset: 7,
},
*/
}];

const getInstance = instanceId => _.find(Instances, { id: instanceId });
const getEncounter = encounterId => _.find(Encounters, { id: encounterId });
const getDifficulty = difficultyId => _.find(DIFFICULTIES, { id: difficultyId });
const getSeason = seasonId => SEASONS[seasonId];

const getEncounterOverrides = (instanceId, encounterId, difficultyId) => {
  const difficulty = getDifficulty(difficultyId);

  // instance + encounter
  let encounterOverrides;
  const allEncounterOverrides = _.filter(
    ENCOUNTER_OVERRIDES,
    {
      encounterId,
    },
  );
  if (difficultyId) {
    encounterOverrides = _.find(
      allEncounterOverrides,
      {
        difficulty: difficultyId,
      },
    );
  } else {
    encounterOverrides = _.find(
      allEncounterOverrides,
      o => !o.difficulty,
    );
  }

  // instance + difficulty
  const instanceDifficultyOverrides = _.find(
    INSTANCE_DIFFICULTY_OVERRIDES,
    {
      instanceId,
      difficulty: difficultyId,
    },
  );

  // general instance overrides
  const instanceOverrides = _.find(
    INSTANCE_OVERRIDES,
    {
      instanceId,
    },
  );

  const instance = getInstance(instanceId);
  const encounter = getEncounter(encounterId);

  let season;
  if (instanceOverrides) {
    season = getSeason(instanceOverrides.season);
  }
  if (encounterOverrides?.season) {
    season = getSeason(encounterOverrides.season);
  }

  const overrides = {};

  _.defaults(
    overrides,
    season,
    encounterOverrides,
    instanceDifficultyOverrides,
    instanceOverrides,
    {
      instance,
      encounter,
      difficulty,
      encounterType: 'boss',
      encounterTypePlural: 'bosses',
      quality: difficulty?.quality ?? 4,

      // add some difficulty options at the top level (but not everything)
      // (Not sure why not everything, need to spend some more time remembering why it wrote it that way)
      itemLevel: _.get(difficulty, 'itemLevel'),
      itemLevelOverride: _.get(difficulty, 'itemLevelOverride'),
      itemLevelOffset: difficulty?.itemLevelOffset,
      gambling: _.get(difficulty, 'gambling'),
      itemFilter: _.get(difficulty, 'itemFilter'),
    },
  );

  return overrides;
};

const getItems = ({
  instance,
  encounter,
  instances, // legacy
  encounters, // legacy
  difficulty,
  warforgeLevel,
  gem,
  classId,
  specId,
  lootSpecId,
  faction,
  // Use static data by default, but allow overrides.
  // This lets reports save a snapshot of the item/instance list from sim time so that
  // things don't break as Droptimizer updates are made.
  // Also means Droptimizer data doesn't need to be loaded on a report page.
  itemLibrary = EncounterItems,
  instanceLibrary = Instances,
  equipped,
  craftedStats,
  craftedGem,
  offSpecItems,
  includeConversions,
}) => {
  if (!itemLibrary && !loaded) {
    // eslint-disable-next-line
    console.warn('Droptimizer is not ready, must call loadStaticData() with proper data');
    return [];
  }

  const selectedInstanceId = instance || _.first(instances);
  const selectedEncounterId = instance ? encounter : _.first(encounters);

  const overrides = getEncounterOverrides(selectedInstanceId, selectedEncounterId, difficulty);

  const baseItems = _.map(
    _.filter(itemLibrary, item => {
      if (!_.includes(_.map(item.sources, 'instanceId'), selectedInstanceId)) {
        return false;
      }

      if (offSpecItems) {
        if (!isItemUsable(item, classId, specId)) {
          return false;
        }
      } else if (!doesItemDrop(item, classId, specId)) {
        return false;
      }

      if (item.faction && item.faction !== faction) {
        return false;
      }

      const encounterId = _.find(item.sources, { instanceId: instance }).encounterId;

      const itemOverrides = getEncounterOverrides(selectedInstanceId, selectedEncounterId || encounterId, difficulty);
      if (itemOverrides.disabled) {
        return false;
      }

      const checkEncounterId = selectedEncounterId && selectedEncounterId !== -1;
      if (checkEncounterId && selectedEncounterId !== encounterId) {
        return false;
      }

      if (itemOverrides.itemFilter) {
        return itemOverrides.itemFilter(item);
      }

      return true;
    }),
  );

  // expand tokens into possible drops
  const expandedItems = [];
  _.each(baseItems, item => {
    if (item.contains) {
      _.each(item.contains, itemId => {
        const it = _.find(itemLibrary, { id: itemId });
        if (it) {
          if (doesItemDrop(it, classId, lootSpecId || specId)) {
            // use the token's item level just in case there's a weird data mismatch.
            // (Paladin chest from Vault of Incarnates had the wrong item level)
            let newItem = {
              ...it,
              // copy sources from the token
              sources: item.sources,
              sourceItem: item,
              fromToken: true,
            };

            // possible that we might need to do some of the base item level shuffling done below
            // Update: we did
            // TODO: Rewrite the target item level handling in all of this using some of the
            // newer item level management code in shared/items.js
            newItem = removeItemLevelBonuses(newItem);
            newItem.itemLevel = newItem.baseItemLevel || newItem.itemLevel;

            expandedItems.push(newItem);
          }
        }
      });
    } else {
      expandedItems.push({ ...item });

      // check for overrides for the encounter for this item
      // this ensures new world bosses use the right item conversion and old bosses keep using the old conversion
      const encounterId = _.find(item.sources, { instanceId: instance }).encounterId;

      const itemOverrides = getEncounterOverrides(selectedInstanceId, selectedEncounterId || encounterId, difficulty);
      const conversion = itemOverrides.itemConversion || overrides.itemConversion;
      if (conversion && includeConversions) {
        const possibleConversions = getPossibleItemConversions(item, specId, conversion.id);
        _.each(possibleConversions, convertedItem => {
          let newItem = {
            ...convertedItem,
            sources: item.sources,
            itemConversion: conversion.id,
            // include a reference to the original item. May need it to handle sources configured with an offset later
            sourceItem: item,
          };

          // we want this item back at its base item level in case we deal with offsets later
          // yeah, it's pretty hacky
          newItem = removeItemLevelBonuses(newItem);
          newItem.itemLevel = newItem.baseItemLevel || newItem.itemLevel;

          newItem = addTag(newItem, 'catalyst');

          expandedItems.push(newItem);
        });
      }
    }
  });

  const equippedNeckGems = _.filter(_.split(equipped?.neck?.gem_id, '/'));

  const items = _.sortBy(
    _.filter(_.map(
      expandedItems,
      item => {
        const slot = slotMap[item.inventoryType];

        const source = _.find(item.sources, { instanceId: selectedInstanceId }) || _.first(item.sources);

        const instanceId = selectedInstanceId || source.instanceId;
        const encounterId = selectedEncounterId || source.encounterId;

        const itemOverrides = getEncounterOverrides(instanceId, encounterId, difficulty);

        let baseBonusIds = item.bonusLists;

        let gems = [];
        let addSocket = false;
        if (slot === 'neck' && _.size(equippedNeckGems)) {
          // Dragonflight!
          // Copy sockets/gems from equipped neck if there are gems in it.
          // Neck sockets can always be matched because of the JC items that can be bough on the AH.
          // Only do this if there are gems. If there are no gems, the craftedGem section below will run
          const equippedNeck = equipped.neck;
          const equippedSocketBonusId = getItemSocketBonusId(equippedNeck);
          const itemSocketBonusId = getItemSocketBonusId(item);
          if (equippedSocketBonusId) {
            // remove any different socket bonus IDs
            if (itemSocketBonusId && itemSocketBonusId !== equippedSocketBonusId) {
              baseBonusIds = _.without(baseBonusIds, itemSocketBonusId);
            }
            addSocket = equippedSocketBonusId;
          }
          gems = equippedNeckGems;
        } else if (itemOverrides.enableSockets && gem && !warforgeLevel && canAddSocket(item, SOCKET_TYPES.PRISMATIC)) {
          // if adding a socket
          addSocket = 8780;
          gems.push(gem);
        } else if (craftedGem) {
          // if handling a crafted item with a default socket
          _.each(item.socketInfo?.sockets, socket => {
            if (socket.type === 'PRISMATIC') {
              gems.push(craftedGem);
            }
          });
        }

        if (!itemOverrides.disableDifficulties) {
          baseBonusIds = _.union(baseBonusIds, _.get(_.find(DIFFICULTIES, { id: difficulty }), 'bonusIds', []));
        }

        const instanceBonusIds = _.get(itemOverrides, 'bonusIds', []);

        const isWeapon = _.includes(['main_hand', 'off_hand'], slot);
        let bonusIds = _.flatten(
          _.map(
            _.union(baseBonusIds, instanceBonusIds),
            bonusId => {
              // adjust level bonus ID to handle warforge level offset
              const isLevelBonus = _.isNumber(GameData.BonusLevels[String(bonusId)]);
              if (warforgeLevel && isLevelBonus) {
                let amount = isWeapon ? _.min([warforgeLevel, 10]) : warforgeLevel;

                const newItemLevel = itemOverrides.itemLevel + amount;
                if (newItemLevel > itemOverrides.warforgeMax) {
                  amount -= newItemLevel - itemOverrides.warforgeMax;
                }

                let warforgeBonusId = null;
                if (amount > 10) {
                  warforgeBonusId = TITANFORGED_BONUS_ID;
                } else if (amount > 0) {
                  warforgeBonusId = WARFORGED_BONUS_ID;
                }
                return _.filter([bonusId + amount, warforgeBonusId]);
              }
              return bonusId;
            },
          ),
        );

        // only keep last level offset bonus ID
        bonusIds = _.filter(_.union(
          // get all non-level-offset bonus IDs
          _.reject(bonusIds, id => GameData.BonusLevels[String(id)]),
          [_.last(_.filter(bonusIds, id => GameData.BonusLevels[String(id)]))],
        ));

        const levelOffset = _.last(
          _.filter(
            _.map(bonusIds, id => GameData.BonusLevels[String(id)]),
          ),
        ) || 0;

        if (addSocket) {
          bonusIds.push(addSocket);
        }

        let itemLevel = (item.baseItemLevel || item.itemLevel) + levelOffset;
        const baseItemLevel = itemLevel;

        const updateItemLevelBonuses = (newLevel) => {
          // find appropriate bonus ID for the full item level offset
          const fullOffset = newLevel - baseItemLevel;
          const levelBonusId = getItemBonusForDelta(fullOffset);

          // remove any existing level adjust bonus IDs
          bonusIds = _.reject(bonusIds, bid => GameData.BonusLevels[bid]);

          // add the right bonus ID
          bonusIds.push(levelBonusId);

          itemLevel = newLevel;
        };

        const { itemLevelOverride } = itemOverrides;
        if (itemLevelOverride) {
          let desiredItemLevel = itemLevelOverride;
          if (_.isFunction(itemLevelOverride)) {
            desiredItemLevel = itemLevelOverride(item);
          }
          updateItemLevelBonuses(desiredItemLevel);
        }

        let encounterLevelOffset = itemOverrides.encounterLevelOffset;

        // check item's other sources for an encounterLevelOffset
        if (!encounterLevelOffset && itemOverrides.enableEncounterLevelOffset) {
          const encounterOffsetLevels = _.filter(_.map(
            item.sources,
            s => _.find(ENCOUNTER_OVERRIDES, eo => eo.encounterId === s.encounterId)?.encounterLevelOffset,
          ));
          encounterLevelOffset = _.first(encounterOffsetLevels);
        }

        // in the case of catalyst conversion and a droptimizer item level offset, we need to make sure
        // the transformed item ends up as the same item level as the original. If these two items have
        // different base levels, we need to handle that offset in addition to the droptimizer offset
        let sourceItemOffset = 0;
        if (item.sourceItem) {
          sourceItemOffset = item.sourceItem.itemLevel - baseItemLevel;
          if (item.sourceItem.slotItemLevelOffsets) {
            sourceItemOffset += item.sourceItem.slotItemLevelOffsets[slot] || 0;
          }
        }

        // NOTE: Important to differentiate between 0 and null/undefined. 0 offset is used for normal raids
        // since that matches the base level of the item
        if (encounterLevelOffset !== undefined) {
          updateItemLevelBonuses(itemLevel + encounterLevelOffset + sourceItemOffset);
        }
        if (itemOverrides.itemLevelOffset !== undefined) {
          updateItemLevelBonuses(itemLevel + itemOverrides.itemLevelOffset + sourceItemOffset);
        }

        const { itemLevelMin } = itemOverrides;
        if (itemOverrides.itemLevelMin) {
          if (itemLevel < itemLevelMin) {
            updateItemLevelBonuses(itemLevelMin);
          }
        }

        // copy enchants/non-prismatic gems from equipped gear
        const equippedEnhancements = {
          enchant_id: null,
          tooltipParams: {
            enchant: null,
          },
        };
        if (equipped) {
          // find the right item to compare against
          const equipSlotLookupMap = {
            finger: 'finger1',
            trinket: 'trinket1',
          };
          const camelSlotName = _.camelCase(slot);
          const equippedSlotName = equipSlotLookupMap[camelSlotName] || camelSlotName;
          const equippedItem = equipped[equippedSlotName];

          if (equippedItem) {
            // check for an existing enchant
            const equippedEnchant = equippedItem.tooltipParams?.enchant || 0;
            equippedEnhancements.enchant_id = equippedEnchant;
            equippedEnhancements.tooltipParams.enchant = equippedEnchant;

            _.each(equippedItem?.socketInfo, (socketInfo, socketType) => {
              if (slot !== 'neck') {
                const socketIsPrismatic = socketType === SOCKET_TYPES.PRISMATIC;
                // funky format of sockets when parsed client side
                const potentialHasSocket = _.find(item.socketInfo?.sockets, { type: socketType });
                if (socketIsPrismatic && addSocket && socketInfo.gemIds.length > 0) {
                  gems.pop();
                  gems.push(socketInfo.gemIds[0]);
                } else if (!socketIsPrismatic && potentialHasSocket) {
                  // copy equipped gem into potential
                  // make sure we keep the prismatic gem from the UI option if present
                  gems.push(...socketInfo.gemIds);
                }
              }
            });
          }
        }

        const difficultyInfo = _.find(DIFFICULTIES, { id: difficulty });

        let itemCraftedStats;
        // only add crafted_stats if the item has the open stat slot
        if (hasCraftedStats(item)) {
          itemCraftedStats = craftedStats;
        }

        if (item.itemConversion && itemLevel < item.itemConversion.minLevel) {
          return null;
        }


        let upgradeBonusId;
        if (overrides.season || itemOverrides.season) {
          const season = _.find(GameData.Seasons, { shortName: itemOverrides.season || overrides.season });
          if (season) {
            if (itemOverrides.maxUpgrade) {
              const currentUpgradeBonus = getSeasonBonusForLevel(season.id, itemLevel);
              const upgradeSet = getBonusUpgradeSet(currentUpgradeBonus);
              const maxUpgradeEntry = _.maxBy(upgradeSet, 'level');
              if (maxUpgradeEntry) {
                //
                // i am here!
                // TODO: May not be working correctly
                //
                updateItemLevelBonuses(maxUpgradeEntry.itemLevel);
                upgradeBonusId = maxUpgradeEntry.bonusId;
              }
            }
            if (!upgradeBonusId && overrides.season) {
              upgradeBonusId = getSeasonBonusForLevel(season.id, itemLevel);
            }
          }
          if (upgradeBonusId) {
            bonusIds.push(upgradeBonusId);
          }
        }


        const newItem = {
          ...item,
          ...equippedEnhancements,
          quality: itemOverrides.quality ?? 4, // default to epic
          itemLevel,
          bonus_id: _.compact(_.union(bonusIds)).join('/'),
          bonusLists: _.compact(_.union(bonusIds)),
          gem_id: _.join(gems, '/'),
          crafted_stats: itemCraftedStats,
          crafting_quality: difficultyInfo?.craftingQuality,
          instanceId,
          encounterId,
          difficulty,
          instance: itemOverrides.instance,
          encounter: itemOverrides.encounter,
          sources: _.filter(item.sources, s => {
            const sourceEncounters = _.flatten(_.map(instanceLibrary, 'encounters'));
            const sourceEncounter = _.find(sourceEncounters, { id: s.encounterId });
            if (!sourceEncounter) {
              return false;
            }
            if (sourceEncounter.faction && sourceEncounter.faction !== faction) {
              return false;
            }
            return true;
          }),
          overrides: itemOverrides,
          offSpecItem: !doesItemDrop(item, classId, specId),
        };

        newItem.socketInfo = itemSocketInfo(newItem);

        return newItem;
      },
    )),
    ['itemLevel', 'inventoryType'],
  );

  const dedupeItems = _.uniqBy(
    items,
    i => {
      const instanceId = i.instanceId;
      let encounterId = i.encounterId;
      // Hacky - this handles All Dungeons but will end up with duplicate profilesets with the same name
      // this is kind of preferable since the same item won't sim multiple times but it does result
      // in hacky simc input
      if (instanceId === -1) {
        encounterId = _.find(i.sources, { instanceId })?.encounterId;
      }
      return _.join([
        i.id,
        instanceId,
        encounterId,
        i.itemLevel,
      ], '-');
    },
  );

  return dedupeItems;
};

// This is probably OK to naively memoize. Finite number of variations though it may be large
const getVariations = ({
  instance,
  encounter,
  instances,
  encounters,
  difficulty,
  warforgeLevel,
  gem,
  classId,
  specId,
  lootSpecId,
  faction,
  equipped,
  mainHandAlternateWeapon,
  offHandAlternateWeapon,
  itemLibrary,
  instanceLibrary,
  craftedStats,
  craftedGem,
  offSpecItems,
  includeConversions,
}) => {
  if (!itemLibrary && !loaded) {
    // eslint-disable-next-line
    console.warn('Droptimizer is not ready, must call loadStaticData() with proper data');
    return [];
  }
  const items = getItems({
    instance,
    encounter,
    instances,
    encounters,
    difficulty,
    warforgeLevel,
    gem,
    classId,
    specId,
    lootSpecId,
    faction,
    itemLibrary,
    instanceLibrary,
    equipped,
    craftedStats,
    craftedGem,
    offSpecItems,
    includeConversions,
  });

  if (!equipped || _.size(equipped) === 0) {
    return null;
  }

  const specInfo = getSpecInfo(classId, specId);

  const variations = [];

  const equippedMainHands = getWeaponHands(equipped.mainHand);

  const hasAlternateWeapons = mainHandAlternateWeapon && offHandAlternateWeapon;

  // generate all variations for the raw item list
  _.each(items, origItem => {
    const item = { ...origItem };

    // figure out slots
    const slots = [];
    const rawSlot = slotMap[item.inventoryType];
    if (_.includes(['finger', 'trinket'], rawSlot)) {
      const doubleSlots = [1, 2];
      _.each(doubleSlots, slotNum => {
        const testSlot = `${rawSlot}${slotNum}`;
        const otherSlotNum = _.first(_.xor(doubleSlots, [slotNum]));
        const otherSlot = `${rawSlot}${otherSlotNum}`;
        const otherItem = equipped[otherSlot];
        const replaceItem = equipped[testSlot];

        // generalize for item categories / item limits
        if (!item.uniqueEquipped || otherItem?.id !== item?.id) {
          slots.push({ slot: testSlot });
        }
        // if our new item and the item we're replacing are both On Use, make a new variation
        // with the replaced trinket in the other slot to test double On Use trinket order
        if (item?.onUseTrinket && replaceItem?.onUseTrinket) {
          // do the unique equipped check again for this variation
          if (!item.uniqueEquipped || item?.id !== replaceItem?.id) {
            slots.push({
              slot: testSlot,
              alternate: {
                ...replaceItem,
              },
              alternateSlot: otherSlot,
              variationName: 'swap_doubleonuse',
            });
          }
        }
      });
    } else if (rawSlot === 'main_hand') {
      // weapon permutations
      const hands = getWeaponHands(item);
      // 1. Handle dual wield scenarios
      //    a. Caveat for specs that use 2h or dual-wield 1h - currently just match what's in their hands.
      //      Fury always want to match double 1h or double 2h because of Single Minded Fury. mixing 2h and 1h
      //      is unlikely to every be optimal. Droptimizer only swaps in one weapon at a time so it won't
      //      ever be testing changing 2x2h to 2x1h
      const dualWield1h = equippedMainHands === '1h' && hands === '1h' && specInfo.dualWield;
      const dualWield2h = equippedMainHands === '2h' && hands === '2h' && specInfo.dualWield2h;
      if (dualWield1h || dualWield2h) {
        const testSlots = ['main_hand', 'off_hand'];
        _.each(testSlots, testSlot => {
          const otherSlot = _.camelCase(_.first(_.xor(testSlots, [testSlot])));
          if (!item.uniqueEquipped || item.id !== equipped[otherSlot]?.id) {
            slots.push({ slot: testSlot });
          }
        });

        if (!item.uniqueEquipped || item.id !== equipped.mainHand?.id) {
          const enchant = _.get(equipped, 'offHand.tooltipParams.enchant');
          slots.push({
            slot: 'main_hand',
            alternate: {
              ...equipped.mainHand,
              // replace with off hand enchant
              enchant_id: enchant,
              tooltipParams: {
                enchant,
              },
            },
            alternateSlot: 'off_hand',
            variationName: 'swap_mh',
          });
        }
      } else if (equippedMainHands === '2h' && (hands === '1h' || hands === 'mh') && !specInfo.dualWield2h) {
        // Some specs can handle 2h staff or MH/OH if alternates are set up from /simc input
        // (All casters and a few melee specs)
        // Fury warriors are not handled here
        if (offHandAlternateWeapon) {
          slots.push({
            slot: rawSlot,
            alternate: {
              ...offHandAlternateWeapon,
              ilevel: offHandAlternateWeapon.itemLevel,
              bonus_id: _.join(offHandAlternateWeapon.bonusLists, '/'),
            },
            alternateSlot: 'off_hand',
          });
          // if spec can dual wield, also try this item in the off hand
          if (specInfo.dualWield && mainHandAlternateWeapon) {
            slots.push({
              slot: 'off_hand',
              alternate: {
                ...mainHandAlternateWeapon,
                ilevel: mainHandAlternateWeapon.itemLevel,
                bonus_id: _.join(mainHandAlternateWeapon.bonusLists, '/'),
              },
              alternateSlot: 'main_hand',
            });
          }
        }
      } else if (!specInfo.dualWield2h) {
        // for everyone but fury warriors, just add the item
        // all valid fury variations should be handled above, this avoids mixing 2h and 1h weapons in the same set
        slots.push({ slot: rawSlot });
      }
    } else if (rawSlot === 'off_hand') {
      if (equippedMainHands !== '2h') {
        slots.push({ slot: rawSlot });
      } else if (equippedMainHands === '2h' && hasAlternateWeapons && mainHandAlternateWeapon) {
        slots.push({
          slot: rawSlot,
          alternate: {
            ...mainHandAlternateWeapon,
            ilevel: mainHandAlternateWeapon.itemLevel,
            enchant_id: _.get(equipped, 'mainHand.tooltipParams.enchant'),
            bonus_id: _.join(mainHandAlternateWeapon.bonusLists, '/'),
          },
          alternateSlot: 'main_hand',
        });
      }
    } else {
      slots.push({ slot: rawSlot });
    }

    const equippedItemLimits = {};
    _.each(equipped, it => {
      if (it.itemLimit) {
        if (!equippedItemLimits[it.itemLimit.category]) {
          equippedItemLimits[it.itemLimit.category] = {
            max: it.itemLimit.quantity,
            count: 0,
          };
        }
        const obj = equippedItemLimits[it.itemLimit.category];
        obj.count += 1;
        if (obj.count === obj.max) {
          obj.full = true;
        }
      }
    });

    _.each(slots, ({ slot, alternate, alternateSlot, variationName }) => {
      const slotItem = { ...item };
      const equippedItem = equipped[_.camelCase(slot)];

      let invalidReason;
      const sameItemIdEquipped = _.get(item, 'id') === _.get(equippedItem, 'id');
      if (sameItemIdEquipped) {
        if (equippedItem.itemLevel >= item.itemLevel) {
          // equipped gem, potential gem = skip potential
          // equipped no gem, potential no gem = skip potential
          // equipped gem, potential no gem = skip potential
          // equipped no gem, potential gem = sim potential
          const equippedHasGem = Boolean(_.get(equippedItem, 'socketInfo.PRISMATIC.filled'));
          const potentialHasGem = Boolean(_.get(item, 'socketInfo.PRISMATIC.filled'));
          const droptimizerGemBetter = !equippedHasGem && potentialHasGem;

          const equippedCraftedStats = _.join(getCraftedStats(equippedItem), '/');
          const droptimizerCraftedStats = _.join(getCraftedStats(item), '/');
          const craftedStatsSame = equippedCraftedStats === droptimizerCraftedStats;

          if (!droptimizerGemBetter && craftedStatsSame) {
            invalidReason = 'equippedSameOrBetter';
          }
        }
      }

      if (variationName === 'swap_doubleonuse') {
        // only need to check ID and item level since this is just trinkets
        const otherEquipped = equipped[_.camelCase(alternateSlot)];
        const mainSwapped = item.id === otherEquipped?.id && item.itemLevel === otherEquipped?.itemLevel;
        const altSwapped = alternate.id === equippedItem.id && alternate.itemLevel === equippedItem.itemLevel;
        if (mainSwapped && altSwapped) {
          invalidReason = 'equippedSameOrBetter';
        }
      }

      // run enchant overrides again to make sure off hands get proper enchant on them
      const enchant = _.get(equippedItem, 'tooltipParams.enchant') || 0;
      _.set(slotItem, 'enchant_id', enchant);
      _.set(slotItem, 'tooltipParams.enchant', enchant);

      // check item limit constraints
      const limitCategory = item.itemLimit?.category;
      const equippedIsCategory = equippedItem?.itemLimit?.category === limitCategory;
      // if the equipped slot is this category, we can swap it in without violating the constraint
      if (limitCategory && !equippedIsCategory && equippedItemLimits[limitCategory]?.full) {
        invalidReason = 'itemLimitCategory';
      }

      const nameParts = [
        slotItem.instanceId,
        slotItem.encounterId,
        slotItem.difficulty,
        slotItem.id,
        slotItem.itemLevel,
        enchant,
        slot,
        variationName,
      ];

      const baseVariation = {
        id: _.join(nameParts, '/'),
        slot,
        item: slotItem,
        invalidReason,
      };

      variations.push({
        ...baseVariation,
        alternate: _.clone(alternate),
        alternateSlot,
        variationName,
      });
    });
  });

  return variations;
};

const shouldCalcRolls = ({ /*gem,*/ warforgeLevel }) => {
  /*
  if (gem) {
    return false;
  }
  */
  if (warforgeLevel > 0) {
    return false;
  }
  return true;
};

export default {
  ready: () => loaded,
  loadStaticData,

  getItems,
  getVariations,
  getInstance,
  getEncounter,
  getEncounterOverrides,
  getDifficulty,

  shouldCalcRolls,

  getEncounters: () => Encounters,
  getInstances: () => Instances,
};
